import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import {firstValueFrom, interval, merge, of} from 'rxjs';
import {catchError, concatMap, filter, map, withLatestFrom} from 'rxjs/operators';
import { stringifyIfNotNullOrUndefined } from '../../../helper/helper';
import { HttpService } from '../../services/http.service';
import { BaseActionTypes } from '../actions/base.actions';
import { State } from '../index';
import { getToken } from '../selectors/base.selectors';
import { OAuthTokenActionTypes } from '../actions/o-auth-token.actions';
import {
    OAuthTokenEntity,
    OAuthTokenEntityFromBackend,
    OAuthTokenEntityFromBackendGRPC
} from '../../entities/o-auth-token.entity';
import {AppGatewayService} from '../../services/app-gateway.service';
import {FolderActionTypes} from '../actions/folder.actions';
import {getFiles} from '../selectors/files.selectors';
import {ProcessActions} from '../actions/process.actions';
import {ProcessEntityFromBackend} from '../../entities/process.entity';

enum ErrorCodes {
    Load = 'OAuth Token Abrufen fehlgeschlagen',
    Modify = 'OAuth Token Bearbeiten fehlgeschlagen',
    Remove = 'OAuth Token Löschen fehlgeschlagen',
    Add = 'OAuth Token Hinzufügen fehlgeschlagen',
}

@Injectable()
export class OAuthTokenEffects {
    // GetOAuthToken$ = createEffect(() => this.actions$.pipe(
    //     ofType(OAuthTokenActionTypes.Load),
    //     withLatestFrom(this.store$.select(getToken)),
    //     concatMap(([action, token]) => {
    //         const queryString = `
    //         query {
    //             oauthtokens {
    //                 ${OAuthTokenEntity.GqlFields}
    //             }
    //         }`;
    //
    //         return this.gatewayHttpService.graphQl({ query: queryString }, { token, retry: true }).pipe(
    //             map(res => {
    //                 return res && res.oauthtokens
    //                     ? OAuthTokenActionTypes.UpdateAll({
    //                           Payload: res.oauthtokens.map(e => OAuthTokenEntityFromBackend(e)),
    //                       })
    //                     : BaseActionTypes.ErrorAction({ Payload: { ToasterMessage: ErrorCodes.Load } });
    //             }),
    //             catchError((err, caught) =>
    //                 of(
    //                     BaseActionTypes.ErrorAction({
    //                         Payload: {
    //                             ToasterMessage: ErrorCodes.Load,
    //                             Err: err,
    //                             Caught: caught,
    //                         },
    //                     }),
    //                 ),
    //             ),
    //         );
    //     }),
    // ));
    GetOAuthToken$ = createEffect(() => this.actions$.pipe(
        ofType(OAuthTokenActionTypes.Load),
        withLatestFrom(this.store$.select(getToken)),
        concatMap(([action, token]) => this.gatewayService
            .Request({ OAuthGetTokens: {} })
            .then((res) => {
                if (Object.keys(res?.Errors || {}).length === 0) {

                    return OAuthTokenActionTypes.UpdateAll({
                                                  Payload: res.OAuthGetTokens.Tokens.map(e => OAuthTokenEntityFromBackendGRPC(e)),
                                              })
                } else {
                    throw res.Errors;
                }
            })
            .catch((err) =>
                BaseActionTypes.ErrorAction({
                    Payload: {
                        ToasterMessage: ErrorCodes.Add,
                        Err: err,
                    },
                }),
            )),
    ));


    constructor(private actions$: Actions, private store$: Store<State>, private gatewayHttpService: HttpService, private gatewayService: AppGatewayService) {}
}
